import { CaseType } from '@brands/services/cases/types/ICase';

import { UserProfile, UserRoleName } from '../../../services/identity/types/UserProfile';
import { INotification, NotificationType } from '../../../services/notification/types/INotification';

const asyncCaseTypes = [CaseType.one_report, CaseType.second_opinion, CaseType.messaging];

export const isLinkedCaseActionNotification = (notification: INotification): boolean =>
  [
    NotificationType.linked_case_created,
    NotificationType.intake_reminder_5_days,
    NotificationType.intake_reminder_10_days,
    NotificationType.schedule_reminder_5_days,
    NotificationType.schedule_reminder_10_days,
  ].includes(notification.type);

// The page a notification opens on click when the backend sets one, which it
// does for the multi-stage notifications the type-based routing in Sidenav has
// no destination for (program paused/canceled, status override, schedule
// reminders). It's the same page the notification's email/SMS link opens.
export const getNotificationPath = (notification: INotification): string | null => {
  const path = notification.payload?.path;
  return typeof path === 'string' && path.startsWith('/') ? path : null;
};

export const isNotificationClickable = (notification: INotification, user: UserProfile): boolean => {
  if (getNotificationPath(notification)) {
    return true;
  }
  if (user.role.name === UserRoleName.Patient && isLinkedCaseActionNotification(notification)) {
    return true;
  }
  if ([NotificationType.case_provider_unassigned, NotificationType.case_ca_unassigned].includes(notification.type)) {
    return false;
  }
  if (
    notification.type === NotificationType.case_canceled &&
    (user.role.name === UserRoleName.Patient || user.role.name === UserRoleName.Provider)
  ) {
    return false;
  }
  if (notification.type === NotificationType.cc_reauthorization_failed && notification.payload?.update_disabled) {
    return false;
  }
  if (notification.payload?.case_type === CaseType.phone_call_scheduled && user.role.name === UserRoleName.Patient) {
    return false;
  }
  if (notification.type === NotificationType.case_updated && asyncCaseTypes.includes(notification.payload?.case_type)) {
    return false;
  }
  return true;
};
